import request from '@/utils/request'

/** 首页用户概况三面板统计（在服务/今年新增/本月新增） */
export function getDashboardUserOverview() {
  return request({ url: '/dashboard/users/overview', method: 'get' })
}

/** 首页今年新增客户行业分布（租赁/买断两组） */
export function getDashboardUserIndustryChart() {
  return request({ url: '/dashboard/users/industry-chart', method: 'get' })
}

/** 首页经销商概况（合约概况 + 资金概况） */
export function getDashboardDealerOverview() {
  return request({ url: '/dashboard/dealers/overview', method: 'get' })
}

/** 首页业绩概况（本年度 + 本月） */
export function getDashboardPerformanceOverview() {
  return request({ url: '/dashboard/performance/overview', method: 'get' })
}

/** 首页租赁业务概况 */
export function getDashboardLeaseOverview() {
  return request({ url: '/dashboard/lease/overview', method: 'get' })
}

/** 首页核心业绩概况（经销 / 直营 / 数字营销业务目标） */
export function getDashboardCoreOverview() {
  return request({ url: '/dashboard/core/overview', method: 'get' })
}

/** 首页售后概况（全局统一数据，Redis 缓存 12 小时） */
export function getDashboardAfterSalesOverview() {
  return request({ url: '/dashboard/aftersales/overview', method: 'get' })
}

